// Local Core Web Vitals reporting.
//
// This is NOT what Shopify's Built for Shopify benchmark reads — Shopify gets
// its numbers from App Bridge (see utils/shopifyNav.js `startWebVitals`, and
// the CDN script in public/index.html). This exists so the same three metrics
// also land in our own console/analytics, which is the only way to see a
// regression before it shows up in the Partner Dashboard weeks later.
//
// ATTRIBUTION build on purpose (same as Discount Prime): the plain build gives
// you a number; the attribution build tells you WHICH element shifted (CLS's
// largestShiftTarget), why LCP was slow (TTFB / resourceLoadDelay /
// resourceLoadTime / elementRenderDelay), and which interaction dragged INP
// (interactionTarget + input/processing/presentation split). Without that, a
// bad number still means re-profiling by hand in devtools.
//
// web-vitals v3 renamed the API: getCLS/getFID/... became onCLS/onINP/onLCP
// (FID is gone — INP replaced it as a Core Web Vital in March 2024). This file
// once called the v2 names against the v3 package and silently threw.
// `import()` keeps web-vitals out of the main bundle.
const reportWebVitals = (onPerfEntry) => {
  if (!onPerfEntry || !(onPerfEntry instanceof Function)) return;

  import('web-vitals/attribution')
    .then(({ onCLS, onINP, onLCP, onFCP, onTTFB }) => {
      // The three Built for Shopify gates: LCP < 2.5s, CLS < 0.1, INP < 200ms.
      onLCP(onPerfEntry);
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      // Diagnostics — not gated on, but they're what tell you WHY LCP moved.
      onFCP(onPerfEntry);
      onTTFB(onPerfEntry);
    })
    .catch((error) => {
      console.error('[reportWebVitals] failed to load web-vitals:', error);
    });
};

export default reportWebVitals;
